import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, BellOff } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const fmt = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 2 });

export const Watchlist = () => {
  const [items, setItems] = useState([]);

  const load = () => api.get("/watchlist").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const remove = async (slug) => {
    await api.delete(`/watchlist/${slug}`).catch(() => {});
    toast.success("Alert removed.");
    load();
  };

  return (
    <div data-testid="account-watchlist" className="mt-6 space-y-3">
      {items.map((w) => (
        <div key={w.slug} data-testid={`account-watch-${w.slug}`} className="flex flex-col gap-3 border border-slate-200 bg-[#F6F4FD]/70 p-5 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <Bell className="h-4 w-4 shrink-0 text-[#6D28D9]" />
            <div>
              <Link to={`/company/${w.slug}`} className="font-display text-lg font-medium text-slate-900 transition-colors hover:text-[#6D28D9]">{w.company_name}</Link>
              <p className="mt-0.5 font-mono2 text-[10px] uppercase tracking-[0.18em] text-slate-500">
                {w.target_price ? `Target ₹${fmt.format(w.target_price)}` : "Every price move"}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-5">
            <div className="text-right">
              <p className="font-mono2 text-sm text-slate-800">₹{fmt.format(w.current_price ?? 0)}</p>
              <p className={`font-mono2 text-[10px] ${w.change_pct >= 0 ? "text-emerald-600" : "text-rose-600"}`}>{typeof w.change_pct === "number" ? `${w.change_pct >= 0 ? "+" : ""}${w.change_pct}%` : "—"}</p>
            </div>
            <button data-testid={`account-watch-remove-${w.slug}`} onClick={() => remove(w.slug)} className="flex items-center gap-1.5 border border-slate-200 px-3 py-2 font-mono2 text-[10px] uppercase tracking-[0.15em] text-slate-500 transition-colors hover:border-rose-600/40 hover:text-rose-700">
              <BellOff className="h-3 w-3" /> Stop
            </button>
          </div>
        </div>
      ))}
      {items.length === 0 && (
        <div className="border border-dashed border-slate-300 px-6 py-10 text-center">
          <p data-testid="account-no-watches" className="font-mono2 text-xs uppercase tracking-[0.25em] text-slate-500">No price alerts yet</p>
          <p className="mt-3 text-sm text-slate-500">Open any company page and tap “Watch this share” to get emailed when its indicative price moves.</p>
        </div>
      )}
    </div>
  );
};
